module.exports = __webpack_public_path__ + "static/media/mls-logo-rr.f6224e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mls-logo-rr.png
// module id = 589
// module chunks = 0